/**
 * Entry IIFE landing hwaffiliate (checkout externo).
 *
 * <script src=".../pixel.hwaffiliate-landing.global.js"></script>
 *
 * Auto-init. Sem pixelId, settings ou chamada a `Pixel()`.
 */

import { BUYGOODS_LANDING_SETTINGS } from './buygoods-settings';
import { startBuygoodsPreset } from './start-preset';

startBuygoodsPreset({
  name: 'hwaffiliate-landing',
  settings: BUYGOODS_LANDING_SETTINGS,
  hopToTop: false,
  scriptPattern: /pixel\.(hwaffiliate|buygoods)-landing/,
});
